export default __webpack_public_path__ + "img/images-row-large.09b36d88.svg";